<div id="content-section">
    <div id="content-main" class="responsive-content-main" [ngStyle]="{ 'margin-right': sidebarMaximized ? '370px' : '270px' }">
        <div id="content-sidebar" [ngClass]="{ 'responsive-content-sidebar': sidebarOpen, 'hide-responsive-sidebar': !sidebarOpen }" [ngStyle]="{ width: sidebarMaximized ? '350px' : '250px' }" style="position: fixed; right: 20px">
            <div class="sticky-top">
                <small class="bg-white">
                  <a href="#" class="d-none d-md-inline" [title]="sidebarMaximized ? 'Minimize Sidebar' : 'Maximize Sidebar'" (click)="sidebarMaximized = !sidebarMaximized; $event.preventDefault()">
                    <i class="fas" [ngClass]="{ 'fa-arrow-left': !sidebarMaximized, 'fa-arrow-right': sidebarMaximized }"></i>
                  </a>
                </small>
            </div>
            <a routerLink="/receipts/new" class="btn btn-primary btn-sm mb-2" style="width: 100%">
                <i class="fas fa-plus-circle"></i>
                &nbsp;New Receipt
            </a>
            <div class="text-center pagination-small-margin pagination-center">
                <pagination
                (pageChanged)="search($event, null)"
                class="pagination-sm"
                [boundaryLinks]="true"
                [totalItems]="count"
                [maxSize]="5"
                [itemsPerPage]="searchParams.per_page"
                [(ngModel)]="searchParams.page"
                previousText="&lsaquo;"
                nextText="&rsaquo;"
                firstText="&laquo;"
                lastText="&raquo;"
                ></pagination>
            </div>
            <div class="text-center pt-1">
                <app-pagination-count
                    [count]="count"
                    singularName="Receipt"
                    pluralName="Receipts"
                ></app-pagination-count>
            </div>
            <hr class="my-1" />
            <div class="clearfix"></div>
            <div class="sticky-top bg-white">
                <h5 class="pt-2">
                <div class="pull-right float-right">
                    <app-clear-search-btn [searching]="searching" (onClick)="clearSearch()"></app-clear-search-btn>
                </div>
                <span>
                    Search&nbsp;&nbsp;
                    <a href="javascript: void(0)" title="Search" style="cursor: pointer" (click)="!searching ? (searchParams.page = 1) && search(null, true) : ''"><i *ngIf="!searching" class="fas fa-arrow-circle-right"></i><i *ngIf="searching" class="fas fa-spinner fa-pulse fa-fw"></i></a>
                </span>
                </h5>
                <hr class="my-1" />
            </div>
            <div class="row">
                <div class="col-md-12">
                    <form>
                        <div class="form-group">
                            <label for="matter-name">Matter Name/Number:</label>
                            <app-matter-search id="matter-name" [placeholder]="'Search and select'" (clearMatter)="searchParams['search[matter_id]'] = undefined" [matterId]="searchParams['search[matter_id]']" [small_input]="false" (matter_id)="searchParams['search[matter_id]']=$event"></app-matter-search>
                        </div>
                        <div class="form-group">
                            <label for="matter-type">Matter Type:</label>
                            <select class="form-control" id="matter-type" [(ngModel)]="searchParams['search[matter_type_id]']" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                                <option [value]=""></option>
                                <option [value]="matterType.id" *ngFor="let matterType of searchOptions.matter_types">{{matterType.name}}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label for="from">From:</label>
                            <app-contact-search id="from" [contactId]="searchParams['search[contact_id]']" (clearContact)="searchParams['search[contact_id]'] = undefined" [placeholder]="'Search and select'" [small_input]="false" (contact_id)="searchParams['search[contact_id]']=$event"></app-contact-search>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-6">
                                <label for="from-date">Date From:</label>
                                <input type="text" class="form-control" #FilterFromDate="ngModel" name="from-date" [(ngModel)]="searchParams['search[date_from]']" placeholder="Click to select date" [appDatepicker]="" (dateSelected)="searchParams['search[date_from]'] = $event" id="fromDate" />
                            </div>
                            <div class="form-group col-md-6">
                                <label for="to-date">Date To:</label>
                                <input type="text" class="form-control" #FilterToDate="ngModel" name="to-date" [(ngModel)]="searchParams['search[date_to]']" placeholder="Click to select date" [appDatepicker]="" (dateSelected)="searchParams['search[date_to]'] = $event" id="toDate" />
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="bank-account">Bank Account:</label>
                            <select class="form-control" id="bank-account" [(ngModel)]="searchParams['search[bank_account_id]']" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                                <option [value]=""></option>
                                <option [value]="bank_account.id" *ngFor="let bank_account of searchOptions.bank_accounts">{{bank_account.name}}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label for="receipt-id">Receipt ID:</label>
                            <input class="form-control" type="number" id="receipt-id" name="receipt-id" [(ngModel)]="searchParams['search[id]']" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                        </div>
                        <div class="form-group">
                            <label for="amount">Amount:</label>
                            <input class="form-control" type="number" id="amount" name="amount" [(ngModel)]="searchParams['search[amount]']" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                        </div>
                        <div class="form-group">
                            <label for="entry-group">Entry Group:</label>
                            <input class="form-control" type="number" id="entry-group" name="entry-group" [(ngModel)]="searchParams.entry_group_ids" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-6">
                                <label for="order-by">Order By:</label>
                                <select class="form-control" id="order-by" [(ngModel)]="searchParams.order_by" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                                    <option value=""></option>
                                    <option *ngFor='let orderBy of searchOptions.order_by' [value]='orderBy.value'>{{orderBy.label}}</option>
                                </select>
                            </div>
                            <div class="form-group col-md-6">
                                <label for="in-order-of">In Order Of:</label>
                                <select class="form-control" id="in-order-of" [(ngModel)]="searchParams.order_direction" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                                    <option value=""></option>
                                    <option *ngFor='let orderDirection of searchOptions.order_direction' [value]='orderDirection.value'>{{orderDirection.label}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="custom-control custom-radio custom-control-inline" (click)="searchParams.reversal = 'all'">
                                <input [checked]="searchParams.reversal == 'all'" type="checkbox" name="type" class="custom-control-input" />
                                <label class="custom-control-label">All</label>
                            </div>
                            <div class="custom-control custom-radio custom-control-inline" (click)="searchParams.reversal = 'hide_reversed'">
                                <input [checked]="searchParams.reversal == 'hide_reversed'" type="checkbox" name="type" class="custom-control-input" />
                                <label class="custom-control-label">Hide Reversed</label>
                            </div>
                            <div class="custom-control custom-radio custom-control-inline" (click)="searchParams.reversal = 'only_reversed'">
                                <input [checked]="searchParams.reversal == 'only_reversed'" type="checkbox" name="type" class="custom-control-input" />
                                <label class="custom-control-label">Only Reversed</label>
                            </div>
                        </div>
                        <div class="form-group">
                            <app-search-btn [searching]="searching" (onClick)="searchParams.page = 1; search(null, true)"></app-search-btn>
                        </div>
                    </form>
                    <div class="row p-4" style="overflow-x:auto;transform: rotateX(180deg);">
                        <table class="table" style="transform: rotateX(180deg);">
                            <thead>
                                <th colspan="2">Waiting to be deposited</th>
                            </thead>
                            <tbody>
                                <tr *ngFor="let bankAccountTotal of bankAccountTotals">
                                    <th>{{bankAccountTotal.name}}</th>
                                    <td class="text-right">
                                        <span *ngIf="bankAccountTotal.bank_account_total">{{bankAccountTotal.bank_account_total | currency: 'USD':'symbol':'1.2-2'}}</span>
                                        <span *ngIf="!bankAccountTotal.bank_account_total"></span>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2">Receipts for query</td>
                                </tr>
                                <tr>
                                    <td>TOTAL:</td>
                                    <td>
                                        <span *ngIf="totalForQuery">{{totalForQuery | currency: 'USD':'symbol':'1.2-2'}}</span>
                                        <span *ngIf="!totalForQuery"></span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div id="content-inner" class="responsive-content-inner" style="padding: 0px 20px 10px 20px">
            <div class="container-shadow px-3 pb-4">
                <h2 class="pt-4 text-center">Receipts</h2>
                <hr class="mt-1 mb-2" />
                <div class="row p-4" style="overflow-x:auto;transform: rotateX(180deg);">
                    <table class="table" style="transform: rotateX(180deg);">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th></th>
                                <th>Group</th>
                                <th>Bank</th>
                                <th>From</th>
                                <th>Date</th>
                                <th>Document</th>
                                <th>Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let receipt of receipts">
                                <td><a [ngClass]="{'lightblue': receipt.color_conditions.light_colored}" [href]="'/receipts/' + receipt.id">{{receipt.id}}</a></td>
                                <td><a [href]="receipt.tree_link_path"><i class="fas fa-tree"></i></a></td>
                                <td><a [ngClass]="{'lightblue': receipt.color_conditions.light_colored}" [href]="'/entry_groups/' + receipt.entry_group_id">{{receipt.entry_group_id}}</a></td>
                                <td><a [ngClass]="{'lightblue': receipt.color_conditions.light_colored}" [href]="'/bank_accounts/' + receipt.bank_account_id">{{receipt.bank_account.name}}</a></td>
                                <td>
                                    <a [ngClass]="{'lightblue': receipt.color_conditions.light_colored}" [routerLink]="'/companies/' + receipt.contact.id" *ngIf="receipt.contact.company_name">{{receipt.contact.display_name}}</a>
                                    <a [ngClass]="{'lightblue': receipt.color_conditions.light_colored}" [routerLink]="'/persons/' + receipt.contact.id" *ngIf="!receipt.contact.company_name">{{receipt.contact.display_name}}</a>
                                </td>
                                <td [ngClass]="{'text-muted': receipt.color_conditions.light_colored}">{{receipt.date}}</td>
                                <td [innerHTML]="receipt.document | safeHtml"></td>
                                <td class="text-right">
                                    <span [ngClass]="{'text-danger': receipt.negative_amount && !receipt.color_conditions.light_colored, 'lightsalmon': receipt.negative_amount && receipt.color_conditions.light_colored}" *ngIf="receipt.amount">{{receipt.amount | currency: 'USD':'symbol':'1.2-2'}}</span>
                                </td>
                            </tr>
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td>Total Receipts for this page are:</td>
                                <td class="text-right">
                                    <span *ngIf="total">{{total | currency: 'USD':'symbol':'1.2-2'}}</span>
                                    <span *ngIf="!total"></span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
<app-sidebar-toggle-btn [sidebarOpen]="sidebarOpen" (onClick)="sidebarOpen = !sidebarOpen"></app-sidebar-toggle-btn>